/*
  Zoekvenster in de header (W5-01, oktober 2026).

  Haalt bij elke toetsaanslag (na 200 ms rust) de HTML van
  sections/predictive-search.liquid op via de Section Rendering API en zet
  die in de Minimog-popup. Minimogs eigen productweergave staat uit via
  data-enable-predictive-search="false" in snippets/search-popup.liquid;
  openen, sluiten en Escape blijven van Minimog.

  Twee verzoeken per zoekterm, allebei af te breken zodra er verder getypt
  wordt:
  - /search/suggest  → de resultaten (suggesties, producten, blogs, categorieën)
  - /search?type=product → alleen het totaal, voor "Bekijk alle (n)".
    Dat getal komt later binnen dan de resultaten; tot dan staat er alleen
    "Bekijk alle".

  Toetsenbord: pijltjes omhoog/omlaag lopen door de opties, Enter opent de
  gekozen optie (zonder keuze gaat het formulier gewoon naar /search),
  Escape haalt eerst de keuze weg en sluit daarna het venster.
*/
(function () {
  'use strict';

  var popup = document.querySelector('[data-search-popup][data-nourished-zoekvenster]');
  if (!popup || !window.fetch || !window.DOMParser) return;

  var input = popup.querySelector('[data-search-input]');
  var box = popup.querySelector('[data-nps]');
  var spinner = popup.querySelector('[data-spinner]');
  var submit = popup.querySelector('button[type="submit"]');
  var clear = popup.querySelector('[data-clear-search]');
  if (!input || !box) return;

  var SECTION = 'predictive-search';
  var WACHT = 200;
  var suggestUrl = popup.dataset.npsSuggestUrl || '/search/suggest';
  var searchUrl = popup.dataset.npsSearchUrl || '/search';
  var rootUrl = popup.dataset.npsRootUrl || '/';

  var velden = ['title', 'vendor', 'product_type', 'variants.title', 'variants.sku'];
  if (popup.dataset.searchByTag === 'true') velden.push('tag');
  if (popup.dataset.searchByBody === 'true') velden.push('body');

  var timer = null;
  var controller = null;
  var laatsteTerm = null;
  var totalen = Object.create(null);
  var leegHtml = null;
  var actief = -1;

  function params(obj) {
    return Object.keys(obj).map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
    }).join('&');
  }

  function laden(aan) {
    if (spinner) spinner.style.visibility = aan ? 'visible' : 'hidden';
    if (submit) submit.style.visibility = aan ? 'hidden' : 'visible';
  }

  function wisknop(aan) {
    if (clear) clear.style.visibility = aan ? 'visible' : 'hidden';
  }

  // Pakt het [data-nps-results]-blok uit een Section Rendering-antwoord.
  function blok(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-nps-results]');
  }

  function haal(url, signal) {
    return fetch(url, { signal: signal, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    });
  }

  function toon(html) {
    box.innerHTML = html;
    actief = -1;
    input.removeAttribute('aria-activedescendant');
    input.setAttribute('aria-expanded', box.querySelector('[role="option"]') ? 'true' : 'false');
  }

  function afbreken() {
    clearTimeout(timer);
    if (controller) controller.abort();
    controller = null;
  }

  function leeg() {
    afbreken();
    laatsteTerm = null;
    laden(false);
    wisknop(false);
    if (leegHtml !== null) return toon(leegHtml);
    toon('');
    controller = new AbortController();
    var sep = rootUrl.indexOf('?') > -1 ? '&' : '?';
    haal(rootUrl + sep + 'section_id=' + SECTION, controller.signal).then(function (html) {
      var el = blok(html);
      leegHtml = el ? el.outerHTML : '';
      if (!input.value.trim()) toon(leegHtml);
    }).catch(function () {});
  }

  function zoek(term) {
    if (term === laatsteTerm) return;
    afbreken();
    laatsteTerm = term;
    controller = new AbortController();
    var signal = controller.signal;
    laden(true);

    var suggest = suggestUrl + '?' + params({
      q: term,
      'resources[type]': 'query,product,article,collection',
      'resources[limit]': 10,
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': velden.join(','),
      section_id: SECTION
    });
    // Zelfde opties als het zoekformulier, zodat het getal klopt met de pagina achter "Bekijk alle".
    var totaal = searchUrl + '?' + params({
      q: term,
      type: 'product',
      'options[prefix]': 'last',
      'options[unavailable_products]': 'last',
      'options[fields]': 'title,vendor,product_type,variants.title',
      section_id: SECTION
    });

    // Een totaal dat we al kennen hoeft niet opnieuw (terug-typen, wissen en opnieuw).
    var telling = term in totalen ? Promise.resolve(totalen[term]) : haal(totaal, signal).then(function (html) {
      var el = blok(html);
      var t = el && el.querySelector('[data-nps-total]');
      if (t) totalen[term] = t.getAttribute('data-nps-total');
      return t ? totalen[term] : null;
    }).catch(function () { return null; });

    haal(suggest, signal).then(function (html) {
      if (signal.aborted) return;
      var el = blok(html);
      toon(el ? el.outerHTML : '');
      laden(false);
      return telling.then(function (n) {
        var plek = !signal.aborted && n !== null && box.querySelector('[data-nps-count]');
        if (plek) plek.textContent = ' (' + n + ')';
      });
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      laden(false);
      laatsteTerm = null;
    });
  }

  function opties() {
    // Alleen zichtbare opties: op mobiel staan product 5 en 6 verborgen.
    return Array.prototype.filter.call(box.querySelectorAll('[role="option"]'), function (o) {
      return o.offsetParent !== null;
    });
  }

  function kies(i) {
    var lijst = opties();
    lijst.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
    if (!lijst.length || i < 0) {
      actief = -1;
      input.removeAttribute('aria-activedescendant');
      return;
    }
    actief = (i + lijst.length) % lijst.length;
    var o = lijst[actief];
    o.setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', o.id);
    o.scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(timer);
    if (!term) return leeg();
    wisknop(true);
    timer = setTimeout(function () { zoek(term); }, WACHT);
  });

  input.addEventListener('focus', function () {
    if (!input.value.trim() && !box.innerHTML) leeg();
  });

  // Capture-fase op de popup: draait vóór Minimogs eigen keydown op het
  // zoekveld, zodat Escape met een gekozen optie alleen de keuze weghaalt.
  popup.addEventListener('keydown', function (e) {
    if (e.target !== input) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!opties().length) return;
      e.preventDefault();
      kies(e.key === 'ArrowDown' ? actief + 1 : (actief < 0 ? -1 : actief - 1));
    } else if (e.key === 'Enter' && actief > -1) {
      var link = opties()[actief] && opties()[actief].querySelector('a');
      if (link) {
        e.preventDefault();
        window.location.href = link.href;
      }
    } else if (e.key === 'Escape' && actief > -1) {
      e.stopPropagation();
      kies(-1);
    }
  }, true);

  // Minimog wist het veld zelf; wij zetten daarna de lege staat terug.
  if (clear) clear.addEventListener('click', function () { setTimeout(leeg, 0); });

  // Zolang het venster open is krijgt <html> een class, zodat de CSS
  // zwevende knoppen van apps (chat, Friends of Nourished, nieuwsbrief)
  // kan verbergen.
  new MutationObserver(function () {
    var open = popup.classList.contains('opacity-100');
    document.documentElement.classList.toggle('nps-open', open);
    if (!open) kies(-1);
  }).observe(popup, { attributes: true, attributeFilter: ['class'] });
})();
